import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-plant-line text-xl text-primary-400"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-background-50">
                  美丽的小蜜桃
                </span>
              </Link>
              <p className="text-sm text-foreground-300 leading-relaxed">
                精选优质产区水蜜桃，鲜嫩甜蜜，产地直发。
                <br />
                每一颗都是大自然的馈赠。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-products" className="text-background-50 hover:text-primary-400 transition-colors">产品中心</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/categories/premium-gift" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    精品礼盒
                  </Link>
                </li>
                <li>
                  <Link to="/categories/fresh-pick" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    鲜摘蜜桃
                  </Link>
                </li>
                <li>
                  <Link to="/categories/fruit-basket" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    水果礼篮
                  </Link>
                </li>
                <li>
                  <Link to="/categories/seasonal" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    时令限定
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-knowledge" className="text-background-50 hover:text-primary-400 transition-colors">蜜桃知识</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/article/a001" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    选购指南
                  </Link>
                </li>
                <li>
                  <Link to="/article/a002" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    保存技巧
                  </Link>
                </li>
                <li>
                  <Link to="/article/a003" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    产区巡礼
                  </Link>
                </li>
                <li>
                  <Link to="/article/a004" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    营养价值
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                <a href="#footer-about" className="text-background-50 hover:text-primary-400 transition-colors">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about#reputation" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    口碑评价
                  </Link>
                </li>
                <li>
                  <Link to="/about#contact" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                    联系我们
                  </Link>
                </li>
              </ul>
              <div className="mt-4 flex gap-3">
                <a href="#wechat" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#weibo" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#douyin" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-background-50 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row justify-between items-center gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 美丽的小蜜桃 版权所有 | 优质水蜜桃产地直发
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-400">
              <a href="#privacy" className="hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#terms" className="hover:text-primary-400 transition-colors">服务条款</a>
              <a href="#sitemap" className="hover:text-primary-400 transition-colors">网站地图</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}